module.exports = __webpack_public_path__ + "img/wx.8220fbd4.jpg";